const groups = [
  {
    icon: 'ri-briefcase-line',
    title: 'Профессиональные компетенции',
    desc: 'Знания и навыки, необходимые для выполнения конкретной работы на должном уровне.',
  },
  {
    icon: 'ri-chat-1-line',
    title: 'Коммуникация',
    desc: 'Умение взаимодействовать с коллегами, клиентами и руководством.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Ответственность',
    desc: 'Способность самостоятельно отвечать за результат и доводить дело до конца.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Инициативность',
    desc: 'Готовность самостоятельно находить решения и предлагать улучшения.',
  },
  {
    icon: 'ri-team-line',
    title: 'Работа в команде',
    desc: 'Способность взаимодействовать с другими и достигать общего результата.',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Управленческие компетенции',
    desc: 'Постановка задач, делегирование, контроль, обратная связь и развитие сотрудников.',
  },
  {
    icon: 'ri-flag-line',
    title: 'Лидерство',
    desc: 'Влияние, принятие ответственности и способность вести других за собой.',
  },
  {
    icon: 'ri-exchange-line',
    title: 'Продажи и переговоры',
    desc: 'Для отдела продаж — навыки коммуникации с клиентами, выявления потребностей, презентации ценности, работы с возражениями и переговоров.',
  },
];

export default function WhatToAssess() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что можно оценивать
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Набор компетенций формируется под конкретную должность и компанию. Ниже — примеры групп, которые чаще всего входят в модель оценки.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {groups.map((g, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${g.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{g.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{g.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm md:text-base text-gray-500 mt-8 max-w-3xl mx-auto leading-relaxed">
          Это не универсальный стандарт, а отправная точка: модель компетенций адаптируется под должность, отрасль и задачи конкретного бизнеса.
        </p>
      </div>
    </section>
  );
}